import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
var ConstructionSiteRemarkComponent = /** @class */ (function () {
    function ConstructionSiteRemarkComponent(snackBar, requestService, requestV2Service) {
        this.snackBar = snackBar;
        this.requestService = requestService;
        this.requestV2Service = requestV2Service;
        this.closeEvent = new EventEmitter();
        this.remark = '';
        this.base64File = null;
        this.filename = null;
        this.isReadingFile = false;
    }
    ConstructionSiteRemarkComponent.prototype.closeRemark = function (subject) {
        this.closeEvent.emit(subject);
    };
    ConstructionSiteRemarkComponent.prototype.send = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var subj, attachment;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isReadingFile) {
                            this.snackBar.open('Votre fichier est en cours de chargement. Veuillez patienter quelques instants puis \
        réessayer.', 'Ok', {
                                duration: 3000
                            });
                            return [2 /*return*/];
                        }
                        subj = {
                            id_project: this.projectId,
                            action: this.remark
                        };
                        attachment = {
                            filename: this.filename,
                            data: this.base64File
                        };
                        if (this.filename !== null || this.base64File !== null) {
                            subj['attachment'] = attachment;
                        }
                        return [4 /*yield*/, this.requestV2Service.addProjectSubject(subj)];
                    case 1:
                        _a.sent();
                        this.snackBar.open('Message envoyé', 'Ok', {
                            duration: 3000
                        });
                        this.closeRemark(true);
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstructionSiteRemarkComponent.prototype.onFileChange = function (event) {
        this.filename = event.target.files[0].name;
        this.getBase64(event.target.files[0]);
    };
    ConstructionSiteRemarkComponent.prototype.getBase64 = function (file) {
        var _this = this;
        this.isReadingFile = true;
        var reader = new FileReader();
        reader.onload = function () {
            _this.isReadingFile = false;
            _this.snackBar.open('Fichier correctement chargé', 'Ok', {
                duration: 3000
            });
            _this.base64File = reader.result;
        };
        reader.onerror = function (error) {
            _this.isReadingFile = false;
            _this.snackBar.open('Une erreur est survenu lors du chargement de votre fichier. Merci de réessayer.', 'Ok', {
                duration: 3000
            });
            console.log(error);
        };
        reader.readAsDataURL(file);
    };
    return ConstructionSiteRemarkComponent;
}());
export { ConstructionSiteRemarkComponent };
